import { useLang } from "@/context/LangContext";
import { BOOKING } from "@/constants/testIds";
import BookingForm from "@/components/BookingForm";

export default function BookingSection() {
  const { t } = useLang();
  return (
    <section
      id="reservar"
      data-testid={BOOKING.section}
      className="bg-[#F9F8F6] py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#F26419] mb-4">
              {t("booking.kicker")}
            </p>
            <h2 className="font-display font-black text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tighter text-[#1A1B1A]">
              {t("booking.title")}
            </h2>
            <p className="mt-6 text-lg text-[#5C635A] leading-relaxed max-w-md">
              {t("booking.intro")}
            </p>
            <div className="mt-10 pt-10 border-t border-[#1A1B1A]/10">
              <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#5C635A] mb-2">
                {t("contact.email.label")}
              </p>
              <a
                href="mailto:sustraiaventura@gmail.com"
                className="font-display text-2xl font-bold text-[#2D5A3C] hover:text-[#F26419] transition-colors break-all"
              >
                sustraiaventura@gmail.com
              </a>
            </div>
          </div>
          <div className="lg:col-span-7">
            <BookingForm />
          </div>
        </div>
      </div>
    </section>
  );
}
